/* eslint-disable prettier/prettier */
import { Navigate, useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import DashboardApp from './pages/DashboardApp';
import Products from './pages/Products';
import Blog from './pages/Blog';
import NotFound from './pages/Page404';
import { Users, Trips, PageContent } from './pages';
import Trip from './pages/Trip';
import Gallery from './pages/Gallery';
import Media from './pages/Media';
import Statute from './pages/Statute';
import PrivacyPolicy from './pages/PrivacyPolicy';

// ----------------------------------------------------------------------

export default function Router() {
  const auth = useSelector((store) => store.auth);
  return useRoutes(
    auth.user
      ? [
          {
            path: '/dashboard',
            element: <DashboardLayout />,
            children: [
              { element: <Navigate to="/dashboard/app" replace /> },
              // ready
              { path: 'users', element: <Users /> },
              { path: 'trips', element: <Trips /> },
              { path: 'trip/:id', element: <Trip /> },
              { path: 'trip/', element: <Trip /> },
              { path: 'content/:name', element: <PageContent /> },
              { path: 'gallery', element: <Gallery /> },
              { path: 'media', element: <Media /> },
              { path: 'statute', element: <Statute /> },
              { path: 'privacy', element: <PrivacyPolicy /> },
              //
              { path: 'app', element: <DashboardApp /> },
              { path: 'products', element: <Products /> },
              { path: 'blog', element: <Blog /> }
            ]
          },
          {
            path: '/',
            element: <LogoOnlyLayout />,
            children: [
              { path: 'login', element: <Login /> },
              { path: '404', element: <NotFound /> },
              { path: '/', element: <Navigate to="/dashboard" /> },
              { path: '*', element: <Navigate to="/404" /> }
            ]
          },
          { path: '*', element: <Navigate to="/404" replace /> }
        ]
      : [
          {
            path: '/',
            element: <LogoOnlyLayout />,
            children: [
              { path: '/', element: <Login /> },
              { path: '404', element: <NotFound /> },
              { path: '*', element: <Navigate to="/404" /> }
            ]
          }
        ]
  );
}
